import { Avatar, Box, Chip, Tooltip, Typography } from "@mui/material"
import LogoIcon from "../../../assets/images/logo-icon.png";
import HandymanIcon from "@mui/icons-material/Handyman";
import { FC, useEffect, useState } from "react";

interface MycomponentProps {
    tools: any[]
}

const AgentPlayGroundTools: FC<MycomponentProps> = (props) => {
    const [tools, setTools] = useState<any[]>([]);


    useEffect(() => {
        if (props.tools && props.tools.length > 0) {
            const toolNames = props.tools.map((tool: any) => tool.name);
            setTools(toolNames);
        }
    }, [props.tools])

    return (<>
        <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
            <Tooltip
                title="Tool Calls"
                slotProps={{
                    popper: {
                        modifiers: [
                            {
                                name: "offset",
                                options: {
                                    offset: [0, -75],
                                },
                            },
                        ],
                    },
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        border: "1px solid gray", // Add border
                        bgcolor: "transparent", // Remove background
                        mr: 2,
                    }}
                >
                    <HandymanIcon sx={{ color: "gray", fontSize: 15 }} />
                </Avatar>
            </Tooltip>
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                }}
            >
                {tools.map((tool, index) => (
                    <Chip
                        key={index}
                        label={tool}
                        variant="outlined"
                        size="small"
                        sx={{
                            lineHeight: "normal",
                        }}
                    />
                ))}
            </Box>
        </Box>


    </>)
}

export default AgentPlayGroundTools